module.exports = __webpack_public_path__ + "static/media/Banan.5c45d3a8.PNG";